import http from "./http-common";

class CreatorService {
  async getAll() {    
   const respons= await http.get(`Creator/GetAll`);   
    return respons
  }  
}

export default new CreatorService();